import { FC, Fragment } from 'react';
import { useGetSubscriptionOffers } from 'src/hooks';
import { SubscriptionOffer } from './SubscriptionOffer';

type Props = {
  store: string;
  cartValue: number;
  hasPrimeDeal?: boolean;
};

export const GetSubscriptionOffers: FC<Props> = ({ store, cartValue, hasPrimeDeal = false }) => {
  const offers = useGetSubscriptionOffers(store, cartValue, hasPrimeDeal);

  return (
    <>
      {offers.map((offer, i) => (
        <Fragment key={`${i}-offer-${offer.name}`}>
          <SubscriptionOffer
            store={store}
            text={offer.text}
            link={offer.link}
            name={offer.name}
            imageSrc={offer.imageSrc}
          />
        </Fragment>
      ))}
    </>
  );
};
